import { useMemo, useState } from 'react';
import { buildEllipsisPreview } from 'shared/helpers/utils/ellipsis-preview';
import { formatSubjectWithLevel } from 'shared/helpers/utils/subject-display';
import type { Subject } from 'services/api';
import styles from './styles.module.scss';

const SUBJECTS_PREVIEW_MAX_CHARS = 128;
const MIN_VISIBLE_SUBJECT_PREFIX_CHARS = 18;

interface SubjectsCellProps {
  subjects?: Subject[] | null;
  maxWidth?: string;
}

export const SubjectsCell = ({ subjects, maxWidth }: SubjectsCellProps) => {
  const [expanded, setExpanded] = useState(false);

  const formattedSubjects = useMemo(
    () =>
      subjects
        ?.map(({ name, educationLevel }) => formatSubjectWithLevel(name, educationLevel))
        .filter(Boolean) ?? [],
    [subjects],
  );

  if (!formattedSubjects.length) {
    return null;
  }

  if (expanded) {
    return (
      <div style={{ maxWidth }}>
        <div>{formattedSubjects.join(', ')}</div>
        <div className={styles.collapseRow}>
          <span onClick={() => setExpanded(false)} className={styles.actionText}>
            Свернуть
          </span>
        </div>
      </div>
    );
  }

  const { visibleText, hiddenCount } = buildEllipsisPreview({
    inputStrings: formattedSubjects,
    previewMaxChars: SUBJECTS_PREVIEW_MAX_CHARS,
    minVisiblePrefixChars: MIN_VISIBLE_SUBJECT_PREFIX_CHARS,
  });

  if (!hiddenCount) {
    return (
      <div className={styles.ellipsisOnlyText} style={{ maxWidth }}>
        {visibleText}
      </div>
    );
  }

  return (
    <div className={styles.collapsedContainer} style={{ maxWidth }}>
      <span className={styles.previewText}>
        {visibleText}
        {visibleText ? ',' : ''}
      </span>
      <span onClick={() => setExpanded(true)} className={styles.actionText}>
        + ещё {hiddenCount}
      </span>
    </div>
  );
};
